import { ClickAwayListener, Collapse, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { PlayerCharacterDisplay, WeaponDisplay as WD, Weapon, PlayerCharacter, CompanionWeapon, CompanionWeaponDisplay } from "../../model/character";
import SimpleTable from "../../components/SimpleTable";
import { ReactNode, useContext, useState } from "react";
import HeadingBar from "../../components/HeadingBar";
import { StatDisplay } from "../../components/StatDisplay";

import { ReactComponent as RangeIcon } from "../../components/icons/raw/Icon_Range.svg";
import { ReactComponent as EnduranceIcon } from "../../components/icons/raw/Icon_End_Damage.svg";
import { ReactComponent as CritDamageIcon } from "../../components/icons/raw/Icon_Crit_Damage.svg";
import { ReactComponent as MunitionsIcon } from "../../components/icons/raw/Icon_Munitions.svg";
import { ReactComponent as DiceIcon } from "../../components/icons/raw/Icon_Dice.svg";
import { ReactComponent as HitIcon } from "../../components/icons/raw/Icon_Hit.svg";
import Hexagon from "../../components/visual/Hexagon";
import { CharacterContext } from "../../model/characterContext";

type TextAlign = 'left' | 'center' | 'right' | 'justify' | 'start' | 'end';

interface CompanionWeaponDisplayProps {
    character: PlayerCharacter;
    characterDisplay: PlayerCharacterDisplay; 
    setCharacter: ( value: PlayerCharacter ) => void;
}

const Header = (props: { children?: ReactNode, tooltip?: string, textAlign?: TextAlign, lineHeight?: any}) => {
    const [ open, setOpen ] = useState(false);

    return <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Tooltip title={props.tooltip} open={open} onClick={() => setOpen(true)} >
            <div style={{textAlign: props.textAlign, height: "100%", lineHeight: props.lineHeight }}>{props.children}</div>
        </Tooltip>
    </ClickAwayListener>
}

const WeaponRow = (props: {
    index: number, display: CompanionWeaponDisplay,
    onClickMunitions: () => void
}) => {
    
    const {display} = props;
    const [ show, setShow ] = useState(false);

    return  <Grid container>
            <Grid item xs={11}>
                <Grid container>
                    <Grid item xs={7}><Typography fontWeight={700} fontSize={15}>{display.name}</Typography></Grid>
                    <Grid item xs={1}>{display.hitDice}<Typography fontSize={"0.75em"} display={"inline"}>d6</Typography></Grid>
                    <Grid item xs={1}>{StatDisplay(display.hitBonus + display.skillBonus)}</Grid>
                    <Grid item xs={1}>{display.range}</Grid>
                    <Grid item xs={1}>{StatDisplay(display.enduranceDamage)}</Grid>
                    <Grid item xs={1}>{display.critDamage}</Grid>
                    
                    <Grid item xs={12}><Typography variant="caption">
                        {display.features.length > 0 && <>Features: {display.features.join(", ")} - </>}
                        {display.weaponType.length > 0 && <>Type: {display.weaponType.join(", ")} - </>}
                        {display.variations.length > 0 && <>Variation {display.variations.join(", ")} - </>}
                        <div>Reload {display.reload}, Slots: {display.slots}, Acquire: {display.acquire}t, Resource: {display.resources}</div>
                        <div>Armour {display.armour}, Durability: {display.durability}, Bodies: {display.bodies}, Defence: {display.defence}, Mobility: {display.mobility}</div>
                        </Typography>
                        </Grid>
                    <Grid item xs={12}><Typography variant="caption"><Collapse in={show}>{display.description}</Collapse></Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={1}><Hexagon onClick={() => props.onClickMunitions()} name="" content={`${3-display.munitionsSpent}/3`}></Hexagon></Grid>
        </Grid>;
}

const CompanionWeaponDisplayer = (props: CompanionWeaponDisplayProps) => {
    const characterContext = useContext(CharacterContext)!;

    const { characterDisplay, character } = characterContext;
    const theme = useTheme();

    const handleMunitions = (id: string) => {
        const weapon = character.companionWeapons.find(cw => cw.id === id)!;
        const indexOf = character.companionWeapons.findIndex(cw => cw.id === id);

        weapon.munitionsSpent = (weapon.munitionsSpent + 1) % 4;

        const weapons = character.companionWeapons;

        weapons[indexOf] = weapon;

        props.setCharacter({
            ...character,
            companionWeapons: weapons
        })
    }

    return <>
        <HeadingBar extendBunts>
            <Grid container paddingX={1} alignItems="center" height="100%">
                <Grid item xs={11}>
                    <Grid container>
                        <Grid item xs={7} lineHeight="0em"><Header lineHeight={"1em"}>Name</Header></Grid>
                        <Grid item xs={1} lineHeight="0em"><Header tooltip="Dice" ><DiceIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
                        <Grid item xs={1} lineHeight="0em"><Header tooltip="Hit Dice"><HitIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
                        <Grid item xs={1} lineHeight="0em"><Header tooltip="Range"><RangeIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
                        <Grid item xs={1} lineHeight="0em"><Header tooltip="Endurance Damage"><EnduranceIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
                        <Grid item xs={1} lineHeight="0em"><Header tooltip="Crit Damage"><CritDamageIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1} lineHeight="0em"><Header textAlign="center" tooltip="Ammo"><MunitionsIcon fill={theme.palette.primary.contrastText} height="1em" /></Header></Grid>
            </Grid>
        </HeadingBar>
        <SimpleTable entries={characterDisplay.companionWeapons.map((w, index) => {
            return <WeaponRow index={index} display={w} onClickMunitions={() => handleMunitions(w.id)}/>
        })} />
    </>
}

export default CompanionWeaponDisplayer